import { ComponentPropsWithoutRef } from 'react';

import { FlexItem } from './FlexItem';

import css from './styles.module.css';

type FlexProps = ComponentPropsWithoutRef<'div'> & {
  gap?: string;
  align?: 'start' | 'center' | 'end';
  justify?: 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly';
  direction?: 'row' | 'column' | 'row-reverse' | 'column-reverse';
};

export function Flex({
  gap,
  children,
  className,
  direction,
  align,
  justify,
  style,
  ...props
}: FlexProps) {
  const classes = [css.flex, className].filter(Boolean).join(' ');
  return (
    <div
      {...props}
      className={classes}
      data-align={align}
      data-justify={justify}
      data-direction={direction}
      style={{ ...style, gap }}
    >
      {children}
    </div>
  );
}

Flex.Item = FlexItem;
